import React, { useEffect, useState } from 'react';
import { NavigationSidebar } from '../components/NavigationSidebar';
import { HeroContent } from '../components/HeroContent';
import { StickyNote } from '../components/StickyNote';
import { MobileMenu } from '../components/MobileMenu';
const backgroundImages = ['https://cdn.magicpatterns.com/uploads/m7k2wd8RGD7udHJAZ91JHj/cjxc0wcJ.jpg', 'https://cdn.magicpatterns.com/uploads/tap6XEXLUCBzJo2qwzpYxZ/EMmHpmEr.jpg', 'https://cdn.magicpatterns.com/uploads/cDJMM9XW5YSAS9oxS7mjby/pVO8l2vF.jpg'];
export function LandingPage() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [previousImageIndex, setPreviousImageIndex] = useState(2);
  const [triggerSlideUp, setTriggerSlideUp] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setPreviousImageIndex(currentImageIndex);
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % backgroundImages.length);
      // Trigger sticky note animation
      setTriggerSlideUp(true);
      // Reset trigger after animation
      setTimeout(() => setTriggerSlideUp(false), 100);
    }, 18000); // Change image every 18 seconds
    return () => clearInterval(interval);
  }, [currentImageIndex]);
  return <div className="min-h-screen w-full relative overflow-x-hidden" data-id="element-269">
      {/* Fonts import */}
      <style data-id="element-270">{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Mono:ital,wght@0,400;0,700;1,400&family=Young+Serif&display=swap');
        
        .font-mono { font-family: 'Space Mono', monospace; }
        .font-serif { font-family: 'Young Serif', serif; }
        
        @keyframes slideUp {
          from { 
            transform: translateY(100%);
          }
          to { 
            transform: translateY(0);
          }
        }
        
        .slide-up {
          animation: slideUp 1.5s ease-out;
        }
      `}</style>

      {/* Cloud decoration at bottom left - fixed position */}
      <img src="https://cdn.magicpatterns.com/uploads/mNAUcU19gm7iDWW9eqHygL/Untitled_design_(3).png" alt="" className="fixed left-0 w-[28rem] md:w-[32rem] h-auto pointer-events-none z-[5] md:z-[15]" style={{
      bottom: '0vh',
      opacity: 0.35
    }} data-id="element-271" />

      {/* Revolving Background */}
      <div className="fixed inset-0 z-0 overflow-hidden grayscale" data-id="element-272">
        {backgroundImages.map((image, index) => {
        const isCurrent = index === currentImageIndex;
        const isPrevious = index === previousImageIndex;
        return <div key={image} className={`absolute inset-0 ${isCurrent ? 'slide-up' : ''}`} style={{
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          transform: isCurrent ? 'translateY(0)' : isPrevious ? 'translateY(0)' : 'translateY(100%)',
          zIndex: isCurrent ? 2 : isPrevious ? 1 : 0,
          visibility: isCurrent || isPrevious ? 'visible' : 'hidden'
        }} data-id="element-273" />;
      })}
      </div>

      <div className="relative z-10 flex min-h-screen" data-id="element-274">
        {/* Logo in top left corner */}
        <div className="fixed top-4 left-4 md:top-2 z-30" style={{
        left: 'calc(1rem)'
      }} data-id="element-275">
          <img src="https://cdn.magicpatterns.com/uploads/hjmCKixQsyBnVGpxJtFJFk/POST_STRANGERS_TEST.png" alt="Post Strangers" className="w-20 md:w-32 h-auto" data-id="element-276" />
        </div>

        {/* Mobile Menu - Only visible on mobile */}
        <MobileMenu data-id="element-277" />

        {/* Desktop Navigation - Hidden on mobile */}
        <div className="hidden md:block" data-id="element-278">
          <NavigationSidebar data-id="element-279" />
        </div>

        <main className="flex-1 flex items-center justify-center p-2 py-8 md:p-4 md:py-12" data-id="element-280">
          <HeroContent data-id="element-281" />
        </main>
      </div>

      {/* Draggable Sticky Note */}
      <StickyNote triggerSlideUp={triggerSlideUp} data-id="element-282" />
    </div>;
}